import { FileUpload } from "components/RFQ/FileUpload";
import { RfxQuoteHeader } from "../../../newui/features/Rfx/Submission/components/QuoteTab/RfxQuoteHeader";
import { convertToFileUploadFormat } from "helpers/fileHelper";
import { FILE_UPLOAD_TYPES, fileUpload } from "newui/components/FileUpload";

export const FlexibleQuoteFile = ({
	rfqId,
	rfxInviteId,
	clientName,
	disabled = false,
	flexibleQuoteSavedFiles,
	isPreview = false,
}) => {
	const fileData = convertToFileUploadFormat(flexibleQuoteSavedFiles);

	const onDeleteFile = async (file) => {
		return fileUpload.util.deleteFileUpload(
			file,
			FILE_UPLOAD_TYPES.FLEXIBLE_QUOTE_FILE_RESPONSE
		);
	};

	return (
		<>
			<RfxQuoteHeader
				title="Alternative Quote / Supporting Documentation"
				description={`${clientName} has allowed you to provide supporting documentation, or if you have an alternative quote upload it here.`}
			>
				{disabled && !fileData ? (
					<div className="my-4 text-gray-500">
						No alternative quote or supporting documentation submitted.
					</div>
				) : (
					<FileUpload
						type="file"
						name={"flexible_quote_files"}
						className="my-4 w-full"
						types={["xlsx", "xls", "csv", "pdf"]}
						multiple={true}
						maxFileSize={100}
						disabled={disabled}
						hideUploadField={disabled && !isPreview}
						existingFiles={fileData}
						fileExtraData={{
							model: FILE_UPLOAD_TYPES.FLEXIBLE_QUOTE_FILE_RESPONSE,
							rfq_id: rfqId,
							rfxInviteId: rfxInviteId,
						}}
						onDelete={onDeleteFile}
					/>
				)}
			</RfxQuoteHeader>
		</>
	);
};
